import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { jobsKeys } from './jobsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.mixdownStatus>>;

export const createFetchMixdownStatusQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ workspaceId, mixdownId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getMixdownJobBackupFilesStatus({ wsid: workspaceId, mixdownId }), signal));
